import { render, staticRenderFns } from "./modifySchemaDrawer.vue?vue&type=template&id=3741ee83"
import script from "./modifySchemaDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./modifySchemaDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./modifySchemaDrawer.vue?vue&type=style&index=0&id=3741ee83&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports